export default __webpack_public_path__ + "static/media/message-web-icon.3947c84f.svg";